export const loadGoogleMapsScript = (apiKey, libraries = []) => {
    return new Promise((resolve, reject) => {
        if (typeof window !== "undefined" && window.google && window.google.maps) {
            resolve(window.google.maps);
            return;
        }

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries.join(",")}`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            if (window.google && window.google.maps) {
                resolve(window.google.maps);
            } else {
                reject("Google Maps failed to load");
            }
        };

        script.onerror = reject;

        document.head.appendChild(script);
    });
};

export const createMap = (container, options) => {
    return new window.google.maps.Map(container, options);
};

export const createMarker = (map, position, options = {}) => {
    return new window.google.maps.Marker({
        map,
        position,
        ...options,
    });
};

export const createInfoWindow = (options) => {
    return new window.google.maps.InfoWindow(options);
};